import React from 'react';

const QuizResult = () => {
  return (
    <div className="section-gap">
      <h1 className="text-3xl font-bold text-text">Quiz Results</h1>
      <p className="text-muted mt-1">Your results will appear here.</p>
    </div>
  );
};

export default QuizResult;
